import { useEffect, useState } from "react";
import client from "../lib/api";
import { Badge } from "./ui/badge";
import { Button } from "./ui/button";
import { Bank, Eye } from "@phosphor-icons/react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";
import EmbeddedPayouts from "./EmbeddedPayouts";

export default function AdminPayoutAccounts() {
  const [list, setList] = useState(null);
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    client.get("/connect/admin/photographers")
      .then((r) => setList(r.data.photographers || []))
      .catch(() => setList([]));
  }, []);

  if (!list) return null;

  const statusBadge = (p) => {
    if (!p.has_account) return <Badge className="bg-[#FAF9F6] text-[#5C5A58] border-[#E9DDC6]">Not started</Badge>;
    if (p.onboarded) return <Badge className="bg-green-100 text-green-800 border-green-200">Ready</Badge>;
    return <Badge className="bg-[#B08D57]/15 text-[#8a6d0a] border-[#B08D57]/40">Setup incomplete</Badge>;
  };

  const sel = list.find((p) => p.id === selected);

  return (
    <div data-testid="admin-payout-accounts">
      <div className="flex items-center gap-2 mb-3">
        <Bank size={18} weight="duotone" className="text-[#4A0000]" />
        <h3 className="font-display text-lg">Photographer payout accounts</h3>
      </div>
      <div className="border border-[#E9DDC6] rounded-md overflow-hidden bg-white">
        <table className="w-full text-sm" data-testid="admin-payout-accounts-table">
          <thead>
            <tr className="bg-[#FAF9F6] text-left text-[#5C5A58]">
              <th className="p-4 font-medium">Photographer</th>
              <th className="p-4 font-medium">Email</th>
              <th className="p-4 font-medium">Payout status</th>
              <th className="p-4 font-medium text-right">Stripe view</th>
            </tr>
          </thead>
          <tbody>
            {list.length === 0 && (
              <tr><td colSpan={4} className="p-8 text-center text-[#5C5A58]" data-testid="admin-payout-empty">No photographers yet.</td></tr>
            )}
            {list.map((p, i) => (
              <tr key={p.id} className={i % 2 ? "bg-[#FBFAF7]" : "bg-white"} data-testid={`admin-payout-row-${p.id}`}>
                <td className="p-4 font-medium">{p.name || "—"}</td>
                <td className="p-4 text-[#5C5A58]">{p.email}</td>
                <td className="p-4">{statusBadge(p)}</td>
                <td className="p-4 text-right">
                  {p.has_account ? (
                    <Button data-testid={`admin-payout-view-${p.id}`} size="sm" variant="outline" className="border-[#E9DDC6]"
                      onClick={() => setSelected(p.id)}>
                      <Eye size={15} className="mr-1" />View in Stripe
                    </Button>
                  ) : <span className="text-xs text-[#9A968E]">Awaiting setup</span>}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <Dialog open={!!sel} onOpenChange={(o) => !o && setSelected(null)}>
        <DialogContent className="max-w-3xl max-h-[88vh] overflow-y-auto" data-testid="admin-payout-embed">
          <DialogHeader>
            <DialogTitle className="font-display text-2xl">{sel?.name || sel?.email}'s payouts</DialogTitle>
            <DialogDescription>Stripe balances, payouts &amp; account details — managed right here, without opening the Stripe dashboard.</DialogDescription>
          </DialogHeader>
          {sel && <EmbeddedPayouts key={sel.id} mode="admin" sessionPath={`/connect/admin/account-session/${sel.id}`} />}
        </DialogContent>
      </Dialog>
    </div>
  );
}
